import { render } from "./TeamsIcon.vue?vue&type=template&id=3c6c2a98"
import script from "./TeamsIcon.vue?vue&type=script&lang=js"
export * from "./TeamsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__